import * as api from '../api/widget';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const WIDGET_FETCH_ALL = createRequestTypes(
  'APPRAISAL/WIDGET_FETCH_ALL',
);
export const WIDGET_UPDATE = createRequestTypes('APPRAISAL/WIDGET_UPDATE');
export const WIDGET_UPDATE_INFO = createRequestTypes(
  'APPRAISAL/WIDGET_UPDATE_INFO',
);
export const WIDGET_FETCH_SINGLE = createRequestTypes(
  'APPRAISAL/WIDGET_FETCH_SINGLE',
);
export const WIDGET_FETCH_INFO = createRequestTypes(
  'APPRAISAL/WIDGET_FETCH_INFO',
);
export const WIDGET_CREATE = createRequestTypes('APPRAISAL/WIDGET_CREATE');
export const WIDGET_LOAD_CODEFILES = createRequestTypes(
  'APPRAISAL/WIDGET_LOAD_CODEFILES',
);
export const WIDGET_RESET_DATA = 'WIDGET_RESET_DATA';

export const fetchWidgets = makeApiActionCreatorV3(
  api.fetchWidgets,
  WIDGET_FETCH_ALL[START],
  WIDGET_FETCH_ALL[SUCCESS],
  WIDGET_FETCH_ALL[ERROR],
);
export const fetchWidget = makeApiActionCreatorV3(
  api.fetchWidget,
  WIDGET_FETCH_SINGLE[START],
  WIDGET_FETCH_SINGLE[SUCCESS],
  WIDGET_FETCH_SINGLE[ERROR],
);
export const fetchWidgetInfo = makeApiActionCreatorV3(
  api.fetchWidgetInfo,
  WIDGET_FETCH_INFO[START],
  WIDGET_FETCH_INFO[SUCCESS],
  WIDGET_FETCH_INFO[ERROR],
);
export const updateWidget = makeApiActionCreatorV3(
  api.updateWidget,
  WIDGET_UPDATE[START],
  WIDGET_UPDATE[SUCCESS],
  WIDGET_UPDATE[ERROR],
);
export const updateWidgetInfo = makeApiActionCreatorV3(
  api.updateWidgetInfo,
  WIDGET_UPDATE_INFO[START],
  WIDGET_UPDATE_INFO[SUCCESS],
  WIDGET_UPDATE_INFO[ERROR],
);
export const createWidget = makeApiActionCreatorV3(
  api.createWidget,
  WIDGET_CREATE[START],
  WIDGET_CREATE[SUCCESS],
  WIDGET_CREATE[ERROR],
);
export const fetchCodeFiles = makeApiActionCreatorV3(
  api.fetchCodeFiles,
  WIDGET_LOAD_CODEFILES[START],
  WIDGET_LOAD_CODEFILES[SUCCESS],
  WIDGET_LOAD_CODEFILES[ERROR],
);
